import { useMutation } from '@tanstack/react-query';

import { IContactUsRequest } from '@/types';
import onApiError from '@/utils/error';

import { contactFormRequest } from '../requests/contact.requests';

interface UseContactUsFormOptions {
  suppressErrorToast?: boolean;
}

export const useContactUsForm = (options: UseContactUsFormOptions = {}) =>
  useMutation({
    mutationFn: async (payload: IContactUsRequest) => {
      const res = await contactFormRequest(payload);
      return res.data;
    },
    ...(options.suppressErrorToast ? {} : { onError: onApiError }),
  });
